import { callList } from '@/lib/rpc/facade';
import type { ListResult } from '@/lib/rpc/types';

export type PayoutRoute = {
  id: string;
  customer_id: string;
  type: 'bank_account' | 'crypto_address';
  label?: string;
  is_default: boolean;
  is_active: boolean;
  metadata?: any;
  created_at: string;
};

export async function getPayoutRoutes(params: {
  limit?: number;
  offset?: number;
} = {}): Promise<ListResult<PayoutRoute>> {
  return callList<PayoutRoute>('user_list_payout_routes', {
    _limit: params.limit ?? 50,
    _offset: params.offset ?? 0
  });
}